import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getLabCatalog, getLabUnits } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabFilterBar from '../components/LabFilterBar';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function UnitHistoryPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [search, setSearch] = useState('');
  const [stationName, setStationName] = useState('');
  const [status, setStatus] = useState('');
  const [ateVersion, setAteVersion] = useState('');
  const [catalog, setCatalog] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    getLabCatalog(sharedQuery).then(setCatalog).catch(() => {});
  }, [sharedQuery]);

  useEffect(() => {
    const params = {};
    if (search) params.search = search;
    if (stationName) params.stationName = stationName;
    if (status) params.status = status;
    if (ateVersion) params.ateVersion = ateVersion;
    Object.assign(params, sharedQuery);
    getLabUnits(params).then((data) => setRows(data.rows || []));
  }, [search, sharedQuery, stationName, status, ateVersion]);

  return (
    <div className="lab-page">
      <LabCard title="Storico unità" description="Storico per seriale con scoring di rischio, ultimo esito e contesto di stazione, versione e testspec.">
        <LabFilterBar>
          <input className="lab-input" placeholder="Cerca seriale, stazione, file, ATE o Testspec" value={search} onChange={(event) => setSearch(event.target.value)} />
          <select className="lab-input" value={stationName} onChange={(event) => setStationName(event.target.value)}>
            <option value="">Tutte le stazioni</option>
            {(catalog?.production?.stations || []).map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
          <select className="lab-input" value={status} onChange={(event) => setStatus(event.target.value)}>
            <option value="">Tutti gli stati</option>
            {(catalog?.production?.statuses || []).map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
          <select className="lab-input" value={ateVersion} onChange={(event) => setAteVersion(event.target.value)}>
            <option value="">Tutte le versioni ATE</option>
            {(catalog?.production?.ateVersions || []).map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
        </LabFilterBar>
        <LabTable
          rows={rows}
          emptyTitle="Nessun upload di produzione trovato."
          emptyDescription="Carica prima i dati di produzione, poi Smarti Lab potrà costruire lo storico unità."
          columns={[
            { key: 'serialNumber', label: 'Seriale', render: (value) => <Link to={`/smarti-lab/units/${encodeURIComponent(value)}`}>{value}</Link> },
            { key: 'latestStatus', label: 'Ultimo stato' },
            { key: 'latestTestStarted', label: 'Ultimo test' },
            { key: 'totalTests', label: 'Test totali' },
            { key: 'failedStepCount', label: 'Step in fail' },
            { key: 'nearLimitCount', label: 'Near-limit' },
            { key: 'ateVersions', label: 'Versioni ATE', render: (value) => (value || []).join(', ') || '—' },
            { key: 'stations', label: 'Stazioni', render: (value) => (value || []).join(', ') || '—' },
            { key: 'riskScore', label: 'Rischio', render: (value) => <div><LabRiskBadge label={value?.label} />{value?.reasons?.length ? <small className="lab-cell-helper">{value.reasons[0]}</small> : null}</div> },
          ]}
        />
      </LabCard>
    </div>
  );
}
